export const githubProjectsData = [
  {
    id: "codepulse",
    title: "CodePulse",
    shortDesc: "AI-Powered Code Analysis Engine",
    programType: "Developer Tools",
    role: "Open Source Creator",
    impact: "A sophisticated Python code analysis tool providing real-time insights into code complexity, quality metrics, and code smells.",
    metrics: { ownership: "End-to-end", scale: "Open Source", architecture: "Advanced", modernTech: "Cutting edge" },
    overview: "Built using Abstract Syntax Tree (AST) to evaluate Python codebases, detect smells, and enforce code quality standards on the fly.",
    scaleComplexity: "Open-source application designed for performance and wide usability.",
    architectureTech: "Python, Flask, AST parsing frameworks.",
    tech: ["Python", "Flask", "AST"],
    outcomes: ["Real-time metric extraction", "AST-based rule engine", "Developer workflow integration | Candidate DNA"],
    businessOutcome: "Open Source Contribution & Community Leadership",
    trendingTechLens: "Developer Tools, Code Analysis, AST",
    link: "https://mytech.ravikishan.in/projects/codepulse/",
    radar: [{ subject: "Scale", A: 70, fullMark: 100 }, { subject: "Ownership", A: 100, fullMark: 100 }, { subject: "Modern", A: 95, fullMark: 100 }, { subject: "Impact", A: 85, fullMark: 100 }, { subject: "Arch", A: 90, fullMark: 100 }]
  },
  {
    id: "finsight",
    title: "FinSight",
    shortDesc: "Financial Analytics Dashboard",
    programType: "FinTech Platform",
    role: "Open Source Creator",
    impact: "A comprehensive financial analytics dashboard featuring simulated stock market data, technical analysis indicators, and portfolio management.",
    metrics: { ownership: "End-to-end", scale: "Open Source", architecture: "Deep", modernTech: "Cloud-native" },
    overview: "Provides deep financial insights, combining market sentiment scoring with interactive Chart.js visualizations for rapid market assessment.",
    scaleComplexity: "Complex UI state management and technical indicator computing.",
    architectureTech: "Python backend, Flask API, interactive Chart.js frontend.",
    tech: ["Python", "Flask", "Chart.js"],
    outcomes: ["Live data simulation", "Technical indicator logic", "Market sentiment scoring engine | Candidate DNA"],
    businessOutcome: "Financial Dashboarding & Algorithmic Analysis",
    trendingTechLens: "FinTech, Data Visualization, Market Analytics",
    link: "https://mytech.ravikishan.in/projects/finsight/",
    radar: [{ subject: "Scale", A: 75, fullMark: 100 }, { subject: "Ownership", A: 100, fullMark: 100 }, { subject: "Modern", A: 90, fullMark: 100 }, { subject: "Impact", A: 90, fullMark: 100 }, { subject: "Arch", A: 85, fullMark: 100 }]
  },
  {
    id: "cybersim",
    title: "CyberSim",
    shortDesc: "Cybersecurity Attack Simulator",
    programType: "Cybersecurity Tool",
    role: "Open Source Creator",
    impact: "A comprehensive cybersecurity platform for professionals to model threats, calculate CVSS risk scores, and simulate multi-stage attacks.",
    metrics: { ownership: "End-to-end", scale: "Open Source", architecture: "Advanced", modernTech: "Cutting edge" },
    overview: "Leverages the Cyber Kill Chain model to allow security engineers to simulate complex attack scenarios against infrastructural nodes safely.",
    scaleComplexity: "Advanced threat modeling algorithms and security math integration.",
    architectureTech: "Python async pipelines powered by FastAPI.",
    tech: ["Python", "FastAPI", "CVSS"],
    outcomes: ["CVSS scoring implementation", "Attack path generation", "Kill-chain stage simulation | Candidate DNA"],
    businessOutcome: "SecOps Training & Risk Management",
    trendingTechLens: "Cybersecurity, Threat Modeling, FastAPI",
    link: "https://mytech.ravikishan.in/projects/cybersim/",
    radar: [{ subject: "Scale", A: 70, fullMark: 100 }, { subject: "Ownership", A: 100, fullMark: 100 }, { subject: "Modern", A: 100, fullMark: 100 }, { subject: "Impact", A: 95, fullMark: 100 }, { subject: "Arch", A: 95, fullMark: 100 }]
  },
  {
    id: "agriwatch",
    title: "AgriWatch",
    shortDesc: "IoT Agricultural Monitoring Platform",
    programType: "AgriTech/IoT System",
    role: "Open Source Creator",
    impact: "Real-time IoT sensor data visualization, crop yield predictions using regression models, and field zone mapping for smart farming.",
    metrics: { ownership: "End-to-end", scale: "Open Source", architecture: "Distributed", modernTech: "IoT / Cloud" },
    overview: "A smart-farming portal that pulls live sensor telemetry and combines it with predictive regression to recommend crop treatments.",
    scaleComplexity: "High data-velocity parsing from edge IoT devices.",
    architectureTech: "Python Flask core integrated with external sensor emulation.",
    tech: ["Python", "Flask", "IoT"],
    outcomes: ["Sensor data ingestion pipeline", "Predictive yield regression", "Real-time crop heatmaps | Candidate DNA"],
    businessOutcome: "AgriTech Innovation & Edge Computing",
    trendingTechLens: "IoT, Smart Agriculture, Predictive ML",
    link: "https://mytech.ravikishan.in/projects/agriwatch/",
    radar: [{ subject: "Scale", A: 80, fullMark: 100 }, { subject: "Ownership", A: 100, fullMark: 100 }, { subject: "Modern", A: 90, fullMark: 100 }, { subject: "Impact", A: 85, fullMark: 100 }, { subject: "Arch", A: 85, fullMark: 100 }]
  },
  {
    id: "chaintrack",
    title: "ChainTrack",
    shortDesc: "Blockchain Supply Chain Integrity",
    programType: "Blockchain Application",
    role: "Open Source Creator",
    impact: "A supply chain integrity platform using SHA-256 hash chains where every event is cryptographically linked, making unauthorized modifications impossible.",
    metrics: { ownership: "End-to-end", scale: "Open Source", architecture: "Immutable", modernTech: "Web3 / Crypto" },
    overview: "A lightweight implementation of hash-linked decentralized tracking, providing absolute transparency over material logistics.",
    scaleComplexity: "Sequential cryptographic hashing and rapid block verification.",
    architectureTech: "High-performance Python hashing algorithms delivered via FastAPI.",
    tech: ["Python", "FastAPI", "SHA-256"],
    outcomes: ["Cryptographic chain validation", "Ledger immutability logic", "Transparent REST verification endpoints | Candidate DNA"],
    businessOutcome: "Logistics Transparency & Web3 Tooling",
    trendingTechLens: "Blockchain, Supply Chain, Cryptography",
    link: "https://mytech.ravikishan.in/projects/chaintrack/",
    radar: [{ subject: "Scale", A: 70, fullMark: 100 }, { subject: "Ownership", A: 100, fullMark: 100 }, { subject: "Modern", A: 95, fullMark: 100 }, { subject: "Impact", A: 90, fullMark: 100 }, { subject: "Arch", A: 95, fullMark: 100 }]
  },
  {
    id: "resumeai",
    title: "ResumeAI",
    shortDesc: "AI-Powered Resume Parser",
    programType: "HR Tech Platform",
    role: "Open Source Creator",
    impact: "Feature-rich resume parser performing skill extraction across 150+ domains, ATS compatibility scoring, and experience level detection.",
    metrics: { ownership: "End-to-end", scale: "Open Source", architecture: "Deep", modernTech: "AI / NLP" },
    overview: "Leverages natural language processing to instantly break down candidate histories and map them perfectly to job description requirements.",
    scaleComplexity: "Unstructured text parsing against deep skill ontologies.",
    architectureTech: "Python NLP extraction pipelines.",
    tech: ["Python", "Flask", "NLP"],
    outcomes: ["Unstructured to structured data parsing", "Semantic skill extraction", "Automated ATS scoring | Candidate DNA"],
    businessOutcome: "HR Automation & Talent Mining",
    trendingTechLens: "NLP, Talent Analytics, Automated Parsing",
    link: "https://mytech.ravikishan.in/projects/resumeai/",
    radar: [{ subject: "Scale", A: 85, fullMark: 100 }, { subject: "Ownership", A: 100, fullMark: 100 }, { subject: "Modern", A: 100, fullMark: 100 }, { subject: "Impact", A: 90, fullMark: 100 }, { subject: "Arch", A: 85, fullMark: 100 }]
  },
  {
    id: "mlexplain",
    title: "MLExplain",
    shortDesc: "Interactive ML Model Explainer",
    programType: "Machine Learning Toolkit",
    role: "Open Source Creator",
    impact: "An educational tool for exploring ML algorithms. Train models instantly, inspect feature importance, and study confusion matrices.",
    metrics: { ownership: "End-to-end", scale: "Open Source", architecture: "Modular", modernTech: "Data Science" },
    overview: "Provides a visual sandbox to compare algorithms side-by-side, breaking down the mathematical 'black box' of standard ML models.",
    scaleComplexity: "In-memory model training and visual plotting generation.",
    architectureTech: "Python and scikit-learn backed visualizations.",
    tech: ["Python", "scikit-learn"],
    outcomes: ["Algorithm comparison sandbox", "Auto-generated feature importance", "Interactive confusion matrices | Candidate DNA"],
    businessOutcome: "ML Education & Transparent AI",
    trendingTechLens: "Explainable AI, Data Science, scikit-learn",
    link: "https://mytech.ravikishan.in/projects/mlexplain/",
    radar: [{ subject: "Scale", A: 65, fullMark: 100 }, { subject: "Ownership", A: 100, fullMark: 100 }, { subject: "Modern", A: 95, fullMark: 100 }, { subject: "Impact", A: 80, fullMark: 100 }, { subject: "Arch", A: 85, fullMark: 100 }]
  },
  {
    id: "traffictwin",
    title: "TrafficTwin",
    shortDesc: "Urban Traffic Digital Twin Simulator",
    programType: "Smart City Engine",
    role: "Open Source Creator",
    impact: "Urban traffic simulation using the Nagel-Schreckenberg cellular automata model with real-time canvas visualization and congestion heatmaps.",
    metrics: { ownership: "End-to-end", scale: "Open Source", architecture: "Advanced", modernTech: "Simulation" },
    overview: "Models vast quantities of individual vehicular objects in real-time, providing deep analytics on choke points and urban planning optimization.",
    scaleComplexity: "Massive object tracking and high-tick visualization loops.",
    architectureTech: "FastAPI stream pumping data into HTML5 Canvas engines.",
    tech: ["Python", "FastAPI", "Canvas"],
    outcomes: ["Cellular automata implementation", "Real-time heatmap rendering", "High-frequency state synchronization | Candidate DNA"],
    businessOutcome: "Smart City Infrastructure Planning",
    trendingTechLens: "Digital Twins, Urban Tech, Object Simulation",
    link: "https://mytech.ravikishan.in/projects/traffictwin/",
    radar: [{ subject: "Scale", A: 90, fullMark: 100 }, { subject: "Ownership", A: 100, fullMark: 100 }, { subject: "Modern", A: 95, fullMark: 100 }, { subject: "Impact", A: 95, fullMark: 100 }, { subject: "Arch", A: 95, fullMark: 100 }]
  },
  {
    id: "moodlens",
    title: "MoodLens",
    shortDesc: "AI Mood Journaling Analytics",
    programType: "Mental Health App",
    role: "Open Source Creator",
    impact: "A mood journaling app with lexicon-based sentiment analysis, emotion tracking across 7 categories, and wellness trend analytics.",
    metrics: { ownership: "End-to-end", scale: "Open Source", architecture: "Modular", modernTech: "NLP / AI" },
    overview: "Parses daily journal inputs to map longitudinal sentiment over time, offering insights into personal wellbeing through categorical AI analysis.",
    scaleComplexity: "Time-series sentiment tracking and contextual NLP parsing.",
    architectureTech: "Python NLP libraries deployed behind a Flask API.",
    tech: ["Python", "Flask", "NLP"],
    outcomes: ["Multi-category sentiment mapping", "Lexicon-based extraction", "Longitudinal graphing | Candidate DNA"],
    businessOutcome: "HealthTech & Behavioral Analytics",
    trendingTechLens: "Sentiment Analysis, HealthTech, NLP",
    link: "https://mytech.ravikishan.in/projects/moodlens/",
    radar: [{ subject: "Scale", A: 75, fullMark: 100 }, { subject: "Ownership", A: 100, fullMark: 100 }, { subject: "Modern", A: 90, fullMark: 100 }, { subject: "Impact", A: 85, fullMark: 100 }, { subject: "Arch", A: 80, fullMark: 100 }]
  },
  {
    id: "sentimentstream",
    title: "SentimentStream",
    shortDesc: "Real-Time Social Media Sentinel",
    programType: "Streaming Analytics",
    role: "Open Source Creator",
    impact: "A real-time sentiment analysis platform monitoring simulated tweet streams, clustering topics, and detecting emerging viral trends instantly.",
    metrics: { ownership: "End-to-end", scale: "Open Source", architecture: "Advanced", modernTech: "Cutting edge" },
    overview: "Built to handle massive simulated social firehoses, identifying positive/negative momentum vectors and grouping topics via machine learning on the fly.",
    scaleComplexity: "High-speed socket stream processing and running rolling aggregations.",
    architectureTech: "FastAPI decoupled streams processing live NLP payloads.",
    tech: ["Python", "FastAPI", "NLP"],
    outcomes: ["Live stream sentiment parsing", "Zero-latency trend detection", "Topic clustering algorithms | Candidate DNA"],
    businessOutcome: "Brand Monitoring & Viral Defense",
    trendingTechLens: "Data Streaming, Topic Clustering, Real-Time AI",
    link: "https://mytech.ravikishan.in/projects/sentimentstream/",
    radar: [{ subject: "Scale", A: 95, fullMark: 100 }, { subject: "Ownership", A: 100, fullMark: 100 }, { subject: "Modern", A: 100, fullMark: 100 }, { subject: "Impact", A: 90, fullMark: 100 }, { subject: "Arch", A: 95, fullMark: 100 }]
  },
  {
    id: "cryptoscope",
    title: "CryptoScope",
    shortDesc: "Crypto Tracker & Analytics",
    programType: "DeFi Tooling",
    role: "Open Source Creator",
    impact: "A cryptocurrency portfolio tracker with P&L calculations, gas fee analysis, and market correlation charts covering massive decentralized data.",
    metrics: { ownership: "End-to-end", scale: "Open Source", architecture: "Distributed", modernTech: "Web3" },
    overview: "Interacts directly with Web3 infrastructure boundaries to compile gas mechanics, token velocities, and multi-asset correlative vectors.",
    scaleComplexity: "Aggregating highly volatile pricing matrices across independent chains.",
    architectureTech: "Flask APIs wrapping dense Web3 interaction scripts.",
    tech: ["Python", "Flask", "Web3"],
    outcomes: ["Multi-asset P&L math", "Gas fee forecasting modeling", "Token correlation rendering | Candidate DNA"],
    businessOutcome: "Decentralized Finance Visibility",
    trendingTechLens: "Web3, DeFi Analytics, Market Tickers",
    link: "https://mytech.ravikishan.in/projects/cryptoscope/",
    radar: [{ subject: "Scale", A: 85, fullMark: 100 }, { subject: "Ownership", A: 100, fullMark: 100 }, { subject: "Modern", A: 95, fullMark: 100 }, { subject: "Impact", A: 85, fullMark: 100 }, { subject: "Arch", A: 85, fullMark: 100 }]
  },
  {
    id: "mediassist",
    title: "MediAssist",
    shortDesc: "Medical Symptom Checker Engine",
    programType: "Healthcare Tech",
    role: "Open Source Creator",
    impact: "A medical symptom checker executing differential diagnosis using weighted overlap and Jaccard similarity algorithms alongside drug interaction warnings.",
    metrics: { ownership: "End-to-end", scale: "Open Source", architecture: "Deep", modernTech: "Health Science" },
    overview: "A sophisticated logic gate for medical correlation, parsing user-input symptoms against pre-programmed knowledge bases to flag critical vectors.",
    scaleComplexity: "Mathematical semantic overlap (Jaccard) spanning medical dictionaries.",
    architectureTech: "Python computational engines exposed through a Flask endpoint.",
    tech: ["Python", "Flask", "MedKB"],
    outcomes: ["Jaccard similarity implementation", "Weighted overlap math arrays", "Multi-drug conflict scanning | Candidate DNA"],
    businessOutcome: "Pre-clinical Triage & Medical Safety",
    trendingTechLens: "Healthcare Algorithms, Assistive Triage, Similarity Math",
    link: "https://mytech.ravikishan.in/projects/mediassist/",
    radar: [{ subject: "Scale", A: 85, fullMark: 100 }, { subject: "Ownership", A: 100, fullMark: 100 }, { subject: "Modern", A: 90, fullMark: 100 }, { subject: "Impact", A: 100, fullMark: 100 }, { subject: "Arch", A: 90, fullMark: 100 }]
  }
];
